import { Controller } from "@hotwired/stimulus";

// Tracks custom events in Google Analytics 4
// Usage:
//   <button data-controller="analytics"
//           data-analytics-event-value="sign_up_click"
//           data-analytics-params-value='{"method": "email"}'
//           data-action="click->analytics#track">
//     Sign Up
//   </button>
export default class extends Controller {
  static values = {
    event: String,
    params: { type: Object, default: {} }
  };

  track() {
    if (typeof window.gtag === "function") {
      window.gtag("event", this.eventValue, this.paramsValue);
    }
  }
}
